import { Stop } from '../types';
import { getTransportIcon } from '../utils/transport';
import './ItineraryRow.css';

interface ItineraryRowProps {
  stop: Stop;
  index: number;
  nights?: number;
  isSelected: boolean;
  onClick: () => void;
}

export default function ItineraryRow({
  stop,
  index,
  nights,
  isSelected,
  onClick,
}: ItineraryRowProps) {
  const transportIcon = getTransportIcon(stop.mode, stop.notes);

  return (
    <div
      className={`itinerary-row ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="row-index">{index + 1}</div>
      <div className="row-icon">{transportIcon}</div>
      <div className="row-content">
        <div className="row-name">{stop.name}</div>
        <div className="row-meta">
          <span className="row-date">{stop.date}</span>
          {nights !== undefined && (
            <span className="row-nights">{nights} nights</span>
          )}
        </div>
      </div>
    </div>
  );
}

